import React, { memo, useEffect } from 'react';
import propTypes from 'prop-types';
import InfoIcon24 from '../../../resources/images/alert-triangle-28.svg';
import Button from '../../global/atoms/button/index.js';
import GlobalModal from '../../global/atoms/globalModal/GlobalModal.js';
import { getAEMCashFlowAlterableData } from '../cashFlow/utils/cashflowUtils.js';
import { VerifyAddressValidationModalTestId } from '../GRTestId.js';
import { useAnalyticsContext } from '../../../config/GoogleTagManagerEvents';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../constants/analyticsConstants/Ecommerce';
import './verifyAddressValidationModal.scss';
import { convertPhoneNumberAsPerSbmChannel } from '../../global/utils/commonUtils.js';

const VerifyAddressValidationModal = ({ verifyAddressModal, onClose }) => {
    const { accountScreenConfig = {} } = getAEMCashFlowAlterableData() || {};
    const {
        editAddressButtonLabel = '',
        yourAddressLabel = '',
        verifyAddressDescription = '',
        callUsAtButtonLabel = ''
    } = accountScreenConfig || {};

    const { sendEventsForGRModalOpened, sendEventsForGRModalCompleted } = useAnalyticsContext();
    const phoneNumber = convertPhoneNumberAsPerSbmChannel(callUsAtButtonLabel);

    useEffect(() => {
        if (verifyAddressModal) {
            sendEventsForGRModalOpened(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_VIEWED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_VERIFY_ADDRESS,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
                ''
            );
        }
    }, []);

    const completedAnalyticEvent = label => {
        sendEventsForGRModalCompleted(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_COMPLETED,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_VERIFY_ADDRESS,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
            label
        );
    };

    const closeEvent = label => {
        onClose();
        sendEventsForGRModalCompleted(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_COMPLETED,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_VERIFY_ADDRESS,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
            label
        );
    };

    const failedVerificationTitle = () => {
        return (
            <>
                <InfoIcon24 tabIndex={'-1'} aria-hidden={true} />
                <span>{yourAddressLabel}</span>
            </>
        );
    };

    const failedVerificationContent = () => {
        return (
            <>
                <span>{verifyAddressDescription}</span>
                <div
                    className="helpmodal__actions"
                    data-testid={VerifyAddressValidationModalTestId.ADDRESS_DESCRIPTION}>
                    {editAddressButtonLabel && (
                        <Button
                            tabIndex={0}
                            buttonAriaLabel={editAddressButtonLabel}
                            className={`button button-primary button-block`}
                            onClick={() => closeEvent(editAddressButtonLabel)}>
                            {editAddressButtonLabel}
                        </Button>
                    )}

                    {callUsAtButtonLabel && (
                        <a
                            href={`tel:${phoneNumber}`}
                            aria-label={phoneNumber}
                            onClick={() => completedAnalyticEvent(phoneNumber)}
                            className={'button button-outline-primary button-block'}>
                            {phoneNumber}
                        </a>
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            <GlobalModal
                titleClasses={'google-address-validation_title'}
                className={'width-327'}
                isOpen={verifyAddressModal}
                onRequestClose={onClose}
                title={failedVerificationTitle()}
                content={failedVerificationContent()}
                handleClose={onClose}
            />
        </>
    );
};

export default memo(VerifyAddressValidationModal);

VerifyAddressValidationModal.propTypes = {
    verifyAddressModal: propTypes.bool,
    onClose: propTypes.func
};
